import { useContext } from "react";
import { Group } from "../utils/types";

import { GroupInfoContext } from "../context/GroupInfoContext";

export const useGroupInfo = () => {
    const groupInfoContextValue = useContext(GroupInfoContext) || ({} as Group);

    return groupInfoContextValue;
};